export default "/images/envelope.svg?0c6f6bf1b6c4bdd30b0b7b57386e6a03";